import React from 'react';
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import './i18n';
import { CLottie } from 'components/atoms';
import { persistor, store } from './store';
import { AppContextProvider } from 'store/context';
import { SnackbarProvider } from 'notistack';
import App from './app';
import { initSentry } from './sentry';
import { CookiesProvider } from 'react-cookie';

const isProd = window.location.href.includes('portal.vetamerikan.org');
if (isProd) {
  initSentry();
}


const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      {/* <CssBaseline /> disable when using Tailwind preflight */}
      <CookiesProvider>
        <Provider store={store}>
          <PersistGate loading={<CLottie isFullPage containerStyle="h-screen" />} persistor={persistor}>
            <AppContextProvider>
              <SnackbarProvider maxSnack={3}>
                <App />
                
              </SnackbarProvider>
            </AppContextProvider>
          </PersistGate>
        </Provider>
      </CookiesProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);

